/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuList } from '@neutron/react';

// styled components
const StyledLegendDataText = styled.p`
  font-size: 0.8rem;
  font-weight: 800;
`;

const StyledLegendList = styled(NeuList)`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  font-size: 0.7rem;
`;

const StyledLegendListItem = styled(NeuList)`
  border: none !important;
`;

const StyledLegendListCont = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.8rem;
`;

const StyledLegendSquare = styled.div`
  height: 0.75rem;
  width: 0.75rem;
  margin: 0 1rem;
  padding-right: 0;
  display: inline-flex;
  ${({ color }: { color: string }) => `
    background: ${color};
  `}
`;

const StyledLegendLabel = styled.div`
  display: inline-flex;
  flex-direction: column;
  font-size: 0.8rem;
`;

export {
  StyledLegendDataText,
  StyledLegendLabel,
  StyledLegendList,
  StyledLegendListItem,
  StyledLegendListCont,
  StyledLegendSquare
};
